export default __webpack_public_path__ + "static/media/trend-neutral-minus.ff2fc595.svg";